export default "__VITE_ASSET__DKzVAr0K__"